var e = "10.29.0+unknown";
//#endregion
export { e as REPORT_PACKAGE_VERSION };
